export default __webpack_public_path__ + "static/media/explore-icon.9ce59e7a.svg";